import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface EditorInChief {
    _id: string;
    fullName: string;
    email: string;
}

interface EditorInChiefContextType {
    editorInChief: EditorInChief | null;
    token: string | null;
    isAuthenticated: boolean;
    logout: () => void;
    loading: boolean;
}

const EditorInChiefContext = createContext<EditorInChiefContextType>({
    editorInChief: null,
    token: null,
    isAuthenticated: false,
    logout: () => { },
    loading: true
});

export const useEditorInChief = () => useContext(EditorInChiefContext);

export const EditorInChiefProvider = ({ children }: { children: ReactNode }) => {
    const [editorInChief, setEditorInChief] = useState<EditorInChief | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('editorInChiefToken');
        const storedEditorInChief = localStorage.getItem('editorInChiefData');

        if (storedToken && storedEditorInChief) {
            setToken(storedToken);
            setEditorInChief(JSON.parse(storedEditorInChief));
        }

        setLoading(false);
    }, []);

    const logout = () => {
        localStorage.removeItem('editorInChiefToken');
        localStorage.removeItem('editorInChiefData');
        setEditorInChief(null);
        setToken(null);
        // This role is embedded as a tab inside the unified dashboard, so logging out
        // here should return to the unified login, not this role's standalone one.
        window.location.href = '/login';
    };

    return (
        <EditorInChiefContext.Provider value={{
            editorInChief,
            token,
            isAuthenticated: !!token && !!editorInChief,
            logout,
            loading
        }}>
            {children}
        </EditorInChiefContext.Provider>
    );
};
